import React from 'react';
import ShortenerForm from '../containers/ShortenerFormContainer'
require('es6-promise').polyfill();


class Shortener extends React.Component {

  handleSubmit = (values) => {
    this.props.submit(values);
  }

  render() {
    return (
        <div>

            <div className="headline">
              <div className="headline__wrapper">
                <h1 className="headline__title">The mighty URL shortener</h1>
                <p className="headline__subtitle">Shorten, share and track clicks. All in one tool.</p>
              </div>
            </div>

            <div className="app">
              <ShortenerForm onSubmit={this.handleSubmit}/>
            </div>

        </div>
    )
  }
}

export default Shortener;



// WEBPACK FOOTER //
// ./src/components/Shortener.jsx